export default __webpack_public_path__ + "static/media/wallet-menu-icon.7177311d.svg";